import * as ls from "local-storage";
import { LocalStorageKeyCollection } from "../../Lib/Constants/KeyCollection/LocalStorageKeyCollection";

export class AccountStorageService {
    constructor() { }

    init(formData?: any) {
        if (document.referrer == null || document.referrer === '') {
            ls.remove(LocalStorageKeyCollection.accountLoginStorage);
            return;
        }

        let referrer = new URL(document.referrer);
        let currentUrl = new URL(window.location.href);

        let params = currentUrl.searchParams;
        let refParam = params.get("ref");

        let cleanUp = refParam != null && refParam.toLowerCase() === "clean";

        if (cleanUp || (this.cleanStorage(referrer, currentUrl) && formData == null)) {
            ls.remove(LocalStorageKeyCollection.accountLoginStorage);
        }

        if (referrer.hostname === currentUrl.hostname && !this.isAccountPage(referrer) && formData != null) {
            ls.set<IAccountStorageObject>(LocalStorageKeyCollection.accountLoginStorage,
                {
                    referrer: referrer.pathname,
                    data: formData,
                    target: currentUrl.pathname + currentUrl.search
                });
        }
    }

    getStorage() {
        return ls.get<IAccountStorageObject>(LocalStorageKeyCollection.accountLoginStorage);
    }
    
    cleanStorage(referrer: URL, currentUrl: URL) {
        if (referrer.hostname !== currentUrl.hostname) return true;
        let data = this.getStorage();

        if (data?.referrer === referrer.pathname) return false;
        if (this.isAccountPage(referrer)) return false;

        return true;
    }

    isAccountPage(url: URL) {
        const pathChunks = url.pathname.split('/')?.filter(x => x.trim() !== '');

        if ((pathChunks.length > 1 && pathChunks[1].toLowerCase() === 'account') || (pathChunks.length > 0 && pathChunks[0].toLowerCase() === 'account')) {
            return true;
        }

        return false;
    }
}

interface IAccountStorageObject {
    data: any;
    referrer: string;
    target: string;
}